/**
 * Regular expression to check value of {@link PageInput} value
 */
export const TABLE_PAGINATION_PAGE_INPUT_REGEXP = /^\d*$/
